import { getResolveContentQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ContentRouteProvider, useContentRoute } from 'src/features/community-hub/hooks/use-content-route';

/**
 * Module layout. Path: /programs/{programSlug}/{moduleSlug}
 * Resolves the program+module slug chain and extends the content-route context
 * with the module (sub-space) id.
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug')({
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      getResolveContentQueryOptions({ program: params.programSlug, module: params.moduleSlug }),
    ),
  component: ModuleRouteWrapper,
});

function ModuleRouteWrapper() {
  const { programSlug, moduleSlug } = Route.useParams();
  const resolved = Route.useLoaderData();
  const parent = useContentRoute();

  return (
    <ContentRouteProvider value={{ ...parent, programSlug, subSpaceId: resolved.module?.id, subSpaceSlug: moduleSlug }}>
      <Outlet />
    </ContentRouteProvider>
  );
}
